import { enrollFactor } from '@wix/ambassador-identity-factors-v1-identity-factor/http';
import {
  FactorType,
  EnrollFactorResponse,
} from '@wix/ambassador-identity-factors-v1-identity-factor/types';
import type { RequestOptionsFactory } from '@wix/http-client';
import { httpClient } from './httpClient';
import { getOriginUrlQueryParam } from '../utils/getOriginUrlQueryParam';
import { serializeRegistrationCredential } from '../utils/credentialSerializer';

const CHECKING_CLIENT_ARTIFACT_ID = 'wix-checking-bm-dashboard';

export class WebAuthnApi {
  public async enrollWebAuthn(
    credential?: Credential,
    accessToken?: string,
    isCheckingPasskeyHeaderEnabled = false,
  ): Promise<EnrollFactorResponse> {
    const serializedCredential = credential
      ? serializeRegistrationCredential(credential as PublicKeyCredential)
      : undefined;

    const factory = enrollFactor({
      factorType: FactorType.WEBAUTHN,
      webauthnData: { credential: serializedCredential },
    });

    const shouldSendCheckingPasskeyHeader =
      getOriginUrlQueryParam() === 'wix-checking' &&
      isCheckingPasskeyHeaderEnabled;
    const requestFactory: RequestOptionsFactory<EnrollFactorResponse> =
      accessToken || shouldSendCheckingPasskeyHeader
        ? (context) => {
            const options = factory(context);
            return {
              ...options,
              headers: {
                ...options.headers,
                ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
                ...(shouldSendCheckingPasskeyHeader && {
                  'X-Wix-Client-Artifact-Id': CHECKING_CLIENT_ARTIFACT_ID,
                }),
              },
            };
          }
        : factory;

    return httpClient.request(requestFactory).then((response) => response.data);
  }
}
